/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { Container } from './styles'
import { useParentCustomer } from '~/hooks/Clients/useParentCustomer'
import { Avatar, Card, Col, Flex, Row, Space, Typography } from 'antd'
import {
  CarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  EditOutlined,
  LoadingOutlined,
} from '@ant-design/icons'
import { translate } from '~/utils/locale'
import CurrencyFormatter from '~/components/DataManipulation/Misc/CurrencyFormater'
import { EditButton } from '~/components/DefaultLayout/Buttons/buttonStyle'

const DetailsFinancialParents: React.FC = () => {
  const { parentCustomer, isLoading, setIsEditFinancial } = useParentCustomer()

  const { Title, Text } = Typography

  if (isLoading || !parentCustomer) {
    return <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
  }

  return (
    <Container>
      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            {translate('ClientsPrincipalTabsFinancial.financialTitleCard')}
          </Title>
        }
        extra={
          <Space>
            <EditButton
              icon={<EditOutlined />}
              onClick={() => setIsEditFinancial(true)}
            >
              {translate('TasksTabsDetails.editButton')}
            </EditButton>
          </Space>
        }
        style={{
          display: 'inline-block',
          width: '100%',
        }}
      >
        <Row>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <DollarOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  Valor da Tarefa
                </Title>
                {parentCustomer?.financial?.task_value ? (
                  <Text>
                    <CurrencyFormatter
                      value={parentCustomer?.financial?.task_value}
                    />
                  </Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
        </Row>

        <Row style={{ marginTop: 14 }}>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <ClockCircleOutlined
                    style={{ fontSize: 12, color: '#464545' }}
                  />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  Quantidade de Horas
                </Title>
                {parentCustomer?.financial?.amount_hours ? (
                  <Text>{parentCustomer?.financial?.amount_hours} horas</Text>
                ) : (
                  <Text>Nenhuma quantidade de horas foi fornecida.</Text>
                )}
              </div>
            </Flex>
          </Col>

          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <DollarOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  Valor Hora Adicional
                </Title>
                {parentCustomer?.financial?.amount_hours_additional ? (
                  <Text>
                    <CurrencyFormatter
                      value={parentCustomer?.financial?.amount_hours_additional}
                    />
                  </Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
        </Row>
        <Row style={{ marginTop: 14 }}>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <CarOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  Quantidade de KM
                </Title>
                {parentCustomer?.financial?.number_km ? (
                  <Text>{parentCustomer?.financial?.number_km} km</Text>
                ) : (
                  <Text>Nenhuma quantidade de km foi fornecida.</Text>
                )}
              </div>
            </Flex>
          </Col>

          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <ClockCircleOutlined
                    style={{ fontSize: 12, color: '#464545' }}
                  />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  Valor KM Adicional
                </Title>
                {parentCustomer?.financial?.number_km_additional ? (
                  <Text>
                    <CurrencyFormatter
                      value={parentCustomer?.financial?.number_km_additional}
                    />
                  </Text>
                ) : (
                  <Text>Nenhuma informação disponível.</Text>
                )}
              </div>
            </Flex>
          </Col>
        </Row>
      </Card>
    </Container>
  )
}

export default DetailsFinancialParents
